var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26.2 24.6",
    style: {
      enableBackground: "new 0 0 26.2 24.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2195F2;}\n\t.st1{fill:#64B4F5;}\n\t.st2{fill:#1A78C2;}\n\t.st3{fill:#15619D;}\n\t.st4{fill:url(#SVGID_1_);}\n\t.st5{fill:#536CB1;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.078,
    y1: 3.1143,
    x2: 6.128,
    y2: 24.6739
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-9,
    style: {
      stopColor: "#5367A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3534,
    style: {
      stopColor: "#5265A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5843,
    style: {
      stopColor: "#4D5F9B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#44558C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9552,
    style: {
      stopColor: "#394777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#354270"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M24.5,14.4c-0.2-0.4-0.3-0.8-0.5-1.1c-0.4-0.7-0.9-1.2-1.5-1.7c-1.2-0.9-2.6-1.5-4-1.8c-1.7-0.3-3.3-0.2-5,0.3 c-1.3,0.4-2.5,1-3.5,2c-0.7,0.7-1.3,1.6-1.5,2.6c-0.3,1.4,0,2.6,0.8,3.8c0.1,0.1,0.1,0.2,0.2,0.3c0,0,0,0,0,0.1 c-3.1,1.1-6.1,0.8-9.2,0c0,0,0,0,0-0.1c0.2,0,0.5-0.1,0.7-0.1c1-0.1,1.9-0.4,2.8-0.8c0.6-0.3,1.1-0.7,1.5-1.2 c0.1-0.1,0.1-0.2,0-0.3c-0.8-0.7-1.4-1.6-1.8-2.6c-0.4-1-0.6-2.1-0.4-3.1C3.2,9.2,3.8,8.1,4.7,7c0.9-1.1,2.1-1.9,3.4-2.5 c1.2-0.6,2.5-0.9,3.8-1.1c1.4-0.2,2.7-0.2,4.1-0.1c1.9,0.2,3.8,0.8,5.4,1.9c1.5,0.9,2.7,2.1,3.4,3.7C25.5,10.7,25.5,12.6,24.5,14.4 C24.5,14.4,24.5,14.4,24.5,14.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M26,20.9c-1.4,0.4-2.7,0.6-4.1,0.5c-0.7,0-1.4-0.2-2.1-0.4c-0.1,0-0.2,0-0.3,0c-0.6,0.1-1.2,0.3-1.9,0.4 c-0.8,0.1-1.5,0.1-2.3,0c-0.9,0-1.7-0.3-2.5-0.6c-0.9-0.4-1.7-0.8-2.5-1.5c-0.7-0.6-1.2-1.3-1.5-2.2c-0.4-1.3-0.2-2.6,0.5-3.7 c0.8-1.2,1.8-1.9,3.1-2.5c0.9-0.4,1.7-0.6,2.7-0.7c0.8-0.1,1.5-0.1,2.3,0c1.6,0.2,3.1,0.7,4.5,1.6c0.9,0.6,1.6,1.5,2,2.5 c0.3,0.9,0.3,1.7,0.1,2.6c-0.3,0.9-0.7,1.6-1.4,2.2c-0.1,0.1-0.1,0.2,0,0.3c0.4,0.5,0.9,0.8,1.5,1.1c0.5,0.2,1.1,0.3,1.7,0.4 C25.9,20.9,25.9,20.9,26,20.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.6c77b4c0eafac35ab9669059cf9b2bb5.svg";
export { ForwardRef as ReactComponent };